import React, { useReducer, useEffect } from 'react';

import StringUtils from 'lib/StringUtils';
import update from 'immutability-helper';
import { useParams, useHistory } from 'react-router-dom';
import If from 'components/widgets/conditional/If';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import MailList from 'components/modules/crm/mail/MailList';
import MailDetail from 'components/modules/crm/mail/MailDetail';
import MailSidebar from 'components/modules/crm/mail/MailSidebar';
import { modules } from 'utils/enum/modules';
import { Communication } from 'utils/enum/SubModule';
import { MEDIA_QUERY } from 'utils/enum/Core';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        display: 'flex',
        overflow: 'hidden',
        position: 'relative',
        flexDirection: 'row',
        color: 'rgb(33, 43, 54)',
        flex: 1,
    },
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: '#fff',
        overflow: 'hidden',
    },
    body: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
    },
    bodyHidden: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            display: 'none',
        },
    },
    sidebarContainer: {
        display: 'flex',
        width: '100%',
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            width: '100%',
            flexDirection: 'column',
        },
    },
    sidebarHidden: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            display: 'none',
        },
    },
    detailContainer: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            backgroundColor: '#fff',
        },
    },
    detailHidden: {
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            display: 'none',
        },
    },
}));

const ACTION_TYPES = {
    TOGGLE_NEW_EMAIL: 'toggleNewEmail',
    TOGGLE_EMAIL_DETAIL: 'toggleEmailDetail',
    TOGGLE_EMAIL_CATEGORY: 'toggleEmailCategory',
    TOGGLE_SHOW_DETAIL: 'toggleShowDetail',
};

const initState = {
    record: {},
    openDetail: false,
    category: 'Inbox',
    showDetail: false,
};

const reducer = (state, action) => {
    switch (action.type) {
    case ACTION_TYPES.TOGGLE_EMAIL_DETAIL: {
        return update(state, {
            openDetail: { $set: action.value },
            record: { $set: action.record },
        });
    }
    case ACTION_TYPES.TOGGLE_EMAIL_CATEGORY: {
        return update(state, {
            category: { $set: action.category },
        });
    }
    case ACTION_TYPES.TOGGLE_SHOW_DETAIL: {
        return update(state, {
            showDetail: { $set: action.value },
        });
    }
    default: return action.value;
    }
};

export default function Mail() {
    const { id } = useParams();
    const history = useHistory();
    const classes = useStyles();
    const isMobile = useMediaQuery(`(max-width:${MEDIA_QUERY.W_430}px)`);
    const [state, dispatch] = useReducer(reducer, initState);

    useEffect(() => {
        if (id && isMobile) {
            dispatch({
                type: ACTION_TYPES.TOGGLE_SHOW_DETAIL,
                value: true,
            });
        } else if (!id && isMobile) {
            dispatch({
                type: ACTION_TYPES.TOGGLE_SHOW_DETAIL,
                value: false,
            });
        }
    }, [id, isMobile]);

    const handleBackToList = () => {
        dispatch({
            type: ACTION_TYPES.TOGGLE_SHOW_DETAIL,
            value: false,
        });
        history.push(`/${modules.COMMUNICATION}/${Communication.MAIL}`);
    };

    const onOpenDetail = (record) => {
        dispatch({
            type: ACTION_TYPES.TOGGLE_EMAIL_DETAIL,
            value: true,
            record,
        });
    };

    const onItemClick = (category) => {
        dispatch({
            type: ACTION_TYPES.TOGGLE_EMAIL_CATEGORY,
            category,
        });
    };

    return (
        <div className={classes.container}>
            <div className={classes.root}>
                <div className={`${classes.sidebarContainer} ${isMobile && state.showDetail ? classes.sidebarHidden : ''}`}>
                    <MailSidebar onItemClick={onItemClick} category={state.category} />
                    <main className={classes.body}>
                        <If condition={state.category === 'Inbox'}>
                            <MailList onOpen={onOpenDetail} />
                        </If>
                        <If condition={state.category === 'Spam'}>
                            <MailList category={state.category} onOpen={onOpenDetail} />
                        </If>
                        {!StringUtils.isEmpty(id) && !isMobile && (
                            <div className={`${classes.detailContainer} ${isMobile && !state.showDetail ? classes.detailHidden : ''}`}>
                                <MailDetail
                                    threadId={id}
                                    to={`/${modules.COMMUNICATION}/${Communication.MAIL}`}
                                    onBackToList={isMobile ? handleBackToList : null}
                                />
                            </div>
                        )}
                    </main>
                </div>
                {!StringUtils.isEmpty(id) && isMobile && (
                    <div className={`${classes.detailContainer} ${isMobile && !state.showDetail ? classes.detailHidden : ''}`}>
                        <MailDetail
                            threadId={id}
                            to={`/${modules.COMMUNICATION}/${Communication.MAIL}`}
                            onBackToList={isMobile ? handleBackToList : null}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
